import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-computer-lab',
  templateUrl: './computer-lab.component.html',
  styleUrls: ['./computer-lab.component.scss']
})
export class ComputerLabComponent implements OnInit {
  activeLightboxImage: string | null = null;

  computerImages = [
    '/assets/img/facilities/imgi_275_computer_lab_image-1200x800.jpg',
    '/assets/img/facilities/imgi_269_computer_lab_img1-1200x800.jpg',
    '/assets/img/facilities/imgi_266_computer_lab_img2-1200x800.jpg',
    '/assets/img/facilities/imgi_263_computer_lab_img3-1200x800.jpg',
    '/assets/img/facilities/imgi_260_computer_lab_img4-1200x800.jpg',
    '/assets/img/facilities/imgi_257_computer_lab_img5-1200x800.jpg',
    '/assets/img/facilities/imgi_254_computer_lab_img6-1200x800.jpg',
    '/assets/img/facilities/imgi_251_computer_lab_img7-1200x800.jpg',
    '/assets/img/facilities/imgi_248_computer_lab_img8-1200x800.jpg',
    '/assets/img/facilities/imgi_245_computer_lab_img9-1200x800.jpg'
  ];

  constructor() { }

  ngOnInit(): void { }

  openLightbox(src: string): void {
    this.activeLightboxImage = src;
  }

  closeLightbox(): void {
    this.activeLightboxImage = null;
  }
}

